import { ActivatedRoute } from '@angular/router';
import { Filtri_Documento } from './../Models/Filtri_Documento';
import { DocumentiStoreService } from './../_services/documenti-store.service';
import { ApiRestService } from './../_services/api-rest.service';
import { Component, Input, OnInit } from '@angular/core';
import { Documento } from '../Models/Documento';
import { ServerPaginationService } from 'src/app/shared/_services/server-pagination.service';
import { Subscription } from 'rxjs';
import { DownloadService } from 'src/app/shared/_services/download.service';
import { ToastrService } from 'ngx-toastr';
import { ApiRestService as FileApiRestService } from './../../shared/_services/api-rest.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Categorie } from '../Models/Categorie';
import { RicercaPaginazione } from 'src/app/Admin/models/sendpersonale';
import {Permission} from "../../Login/_guards/Permission";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-lista-documenti',
  templateUrl: './lista-documenti.component.html'
})
export class ListaDocumentiComponent implements OnInit {
  categoriedropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: true,
    textField: 'categoria',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  DropdownSources: { CategorieLineare: Categorie[]; } = {CategorieLineare: []}
  type: string;
  subscriptions: Subscription = new Subscription();
  collectionSize: number = 0;
  Documenti: Documento[] = [];
  Selected: Documento;
  Filtri: Filtri_Documento = { page: 1, size: 200, old: false, cat_id: undefined };
  @Input() HideCat: boolean = false;
  page = 1;
  pageSize = 50;
  pagesizeserver = 4 // pagine da precaricare da lserver
  newpagegenerated = 1; // pagina per cui è stata fatta la richiesta al server
  campi = (environment['Documenti'] ? environment['Documenti']['campiDocumento'] : null) ?? [
    {
      modificabile: true,
      nome: 'Descrizione',
      oggetti: ['descrizione'],
      inputType: 'text',
      titleClass: 'control-label col-form-label',
      class: 'col-lg-12',
      visibleifProhibited: true
    },
    {
      modificabile: true,
      nome: 'Revisione',
      oggetti: ['revisione'],
      inputType: 'text',
      titleClass: 'control-label col-form-label',
      class: 'col-lg-12',
      visibleifProhibited: true
    },
    {
      modificabile: true,
      nome: 'Old',
      oggetti: ['old'],
      inputType: 'checkbox',
      titleClass: 'control-label col-form-label',
      class: 'col-lg-12',
      visibleifProhibited: true
    },
    {
      modificabile: true,
      nome: 'File',
      oggetti: [null],
      inputType: 'file',
      placeholder: '(pdf,doc,docx,xls,xlsx,jpg,png,txt,ods,odt) Size Limit: 75.00 MB',
      visibleifProhibited: true
    },

    // {nome:'Via email:', ogge
  ]
  constructor(
    private modalService: NgbModal,
    private ApiRestService: ApiRestService,
    private documentiStore: DocumentiStoreService,
    private paginationService: ServerPaginationService,
    private downloadService: DownloadService,
    private fileApiRestService: FileApiRestService,
    private toastService: ToastrService,
    private route: ActivatedRoute,
    public permission: Permission
  ) { }

  ngOnInit() {
    this.route.params.subscribe(data => {
      this.type = data['type'];
      this.HideCat = this.HideCat || (data['nocat'] == '1')
      console.log("Url Data Lista :", data)
      if(!this.type)
      this.campi = [...this.campi,  {
      modificabile: true,
      nome: 'Categorie',
      oggetti: ['categorie'],
      inputType: 'singleDropdown',
      source: 'CategorieLineare',
      OnFilter: 'filtroCategoria',
      internalOutput: 'Categorie',
      hideif:{fieldexist:'id'},
      placeholder: 'Seleziona',
      settings: {
        singleSelection: false,
        idField: 'id',
        textField: 'categoria',
        searchPlaceholderText: "inserire almeno 3 caratteri",
        allowSearchFilter: true,
        allowRemoteDataSearch: true,
      },
      class: 'col-lg-12',
      visibleifProhibited: true
    },]
      this.refreshTable(1);
    });
    this.subscriptions.add(this.documentiStore.$categorieCercate.subscribe(data => {
      this.DropdownSources.CategorieLineare = data ?? [];
      console.log("Categorie", this.DropdownSources.CategorieLineare)
    }));
    this.subscriptions.add(this.documentiStore.$documenti.subscribe(data => {
      if (data && data != null) {
        this.collectionSize = data.total;
        this.Documenti = data.data;
      }
    }))
  }
  add() {

  }
  edit(item: Documento) {
    if(this.permission.isPermitted('gestione-documenti')){
      this.documentiStore.updateDocumentoSelezionato(item);
      this.documentiStore.updateEditable(true);
      this.documentiStore.updateAddable(false);
    }
    //this.router.navigate([this.route.snapshot.queryParams[' progetti/progetto '] || 'progetti/progetto',])
  }
  delete(item: Documento) {
    if (confirm("Sei sicuro di voler eliminare questo elemento?")) {
      this.ApiRestService.deleteDocumento({ id: item.id }).subscribe(() => this.refreshTable(this.newpagegenerated));
    }
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page: number) {
    console.log('pagina generata', this.newpagegenerated)
    this.Filtri.size = this.pagesizeserver * this.pageSize;
    this.Filtri.page = (page - 1) / this.pagesizeserver + 1;
    if (this.type)
      this.Filtri.cat_id = parseInt(this.type);
    this.documentiStore.getCategorie(new RicercaPaginazione('', undefined, undefined))
    this.documentiStore.getDocumenti(this.Filtri);
  }
  download(item: Documento) {
    var idAllegato = parseInt(item.allegato);
    if (!isNaN(idAllegato)) {
      this.fileApiRestService.downloadFle(idAllegato).subscribe(data => {
        this.downloadService.downloadFile(data)
      });
    } else {
      this.toastService.info("Allegato non disponibile", "Ooops!")
    }
  }
  openEditModal(targetModal: NgbModal, item?: Documento) {
    if(this.permission.isPermitted('gestione-documenti')) {
      if (item) {
        this.ApiRestService.getDocumento(item).subscribe(data => {
          this.modalService.open(targetModal, {
            centered: true,
            backdrop: 'static'
          });
          console.log("Documento:",data)
          if (data)
            this.Selected = data;
        });
      } else {
        this.Selected = new Documento();
        if(this.type)
          this.Selected.categorie = [parseInt(this.type)]
        this.modalService.open(targetModal, {
          centered: true,
          backdrop: 'static'
        });
      }
    }else if(item) {
      this.download(item)
    }
  }
  closeBtnClick() {
    this.modalService.dismissAll();
    this.refreshTable(this.newpagegenerated);
  }
  saveModal() {
    this.Selected.categorie = this.Selected?.categorie?.map(x => x.id);
    if (this.Selected?.Categorie) {
      this.Selected.categorie = this.Selected.Categorie.map(x=>x.id);
    }

    if (!isNaN(this.Selected.allegato)) {
      this.Selected.allegato = undefined;
      this.Selected.file = undefined;
    }
    this.Selected['checks'] = this.Selected['checks']?.filter(x => x.risposta)?.map(x => x.id)
    if (this.Selected.id && !isNaN(this.Selected.id)) {
      this.ApiRestService.updateDocumento(this.Selected).subscribe(() => this.closeBtnClick(), (errore) => this.closeBtnClick() );
    } else {
      this.ApiRestService.addDocumento(this.Selected).subscribe(() => this.closeBtnClick(), (errore) => this.closeBtnClick() );
    }
  }


  Filter(filter: { OnFilter: string; Event: any }) {
    switch (filter.OnFilter){
      case 'filtroCategoria':
        this.documentiStore.getCategorie(new RicercaPaginazione(filter.Event, undefined, undefined));
        break;
    }
  }
}
